module.exports = __webpack_public_path__ + "img/2_fineTeam_zsb.afbbf5e0.png";